import { iamAccountIsRoot, identityAccountId } from "@common/domain";
import { iamAccountId } from "./iamAccountId";
import { iamAccountIdentity } from "./iamAccountIdentity";
import { iamAccountRawPassword } from "./iamAccountRawPassword";

export const iamAccountEntityRaw = {
  type: "object",
  required: ["id", "identity", "identityAccountId", "isRoot"],
  properties: {
    id: iamAccountId,
    identity: iamAccountIdentity,
    password: iamAccountRawPassword,
    identityAccountId,
    isRoot: iamAccountIsRoot
  },
  additionalProperties: false
};
